import { createContext, type Context } from 'react';

import type { AudienceScopeContextValue } from './types';

export const RovoTargetingAudienceContext: Context<AudienceScopeContextValue> =
	createContext<AudienceScopeContextValue>({
		productKey: '',
		hasRovoAccess: false,
		gateEnabled: false,
		scopeKey: 'unsupported',
	});
